import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface OrderForm {
  supplierId: string
  documentNumber: string
  amountCents: number
  contact: string
  externalId: string
}

export interface OrderState {
  orderData: OrderForm | null
  selectedPlanId: string | null
  selectedInstallmentId: string | null
}

const initialState: OrderState = {
  orderData: null,
  selectedPlanId: null,
  selectedInstallmentId: null,
}

const orderSlice = createSlice({
  name: 'order',
  initialState,
  reducers: {
    updateOrderData: (state, action: PayloadAction<OrderForm | null>) => {
      state.orderData = action.payload
    },
    resetOrderData: (state) => {
      state.orderData = null
    },
    updateSelectedPlan: (state, action: PayloadAction<string | null>) => {
      state.selectedPlanId = action.payload
    },
    updateInstallmentId: (state, action: PayloadAction<string | null>) => {
      state.selectedInstallmentId = action.payload
    },
  },
})

export const {
  updateOrderData,
  resetOrderData,
  updateSelectedPlan,
  updateInstallmentId,
} = orderSlice.actions

export default orderSlice.reducer
